import { ComponentFactoryResolver, Injector, OnInit, Directive } from '@angular/core';
import { Subject } from 'rxjs';
import { CustomerIdentificationType } from '../../../customer/models/enums/customer-identification-type.enum';
import { CustomerService } from '../../../customer/shared/customer.service';
import { Jurisdiction } from '../../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../base-components/base.component';
import { MvdModalService } from '../../services/modal/mvd-modal.service';
import { SearchResultService } from '../search/search-results/search-result.service';
import { CustomerSearchViewModalComponent, CustomerSearchViewContext } from './search-modal.component';

@Directive()
export class BaseCustomerAdvancedResultsComponent extends BaseComponent implements OnInit {
    protected results: any;
    public result: any;
    public onItemSelected: Subject<any>;
    public onItemRemoved: Subject<void>;

    jurisdictions: Jurisdiction = new Jurisdiction();

    private customerIdentificationTypes: CustomerIdentificationType = new CustomerIdentificationType();

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected injector: Injector,
        protected searchResultService: SearchResultService,
        protected customerService: CustomerService,
        protected modalService: MvdModalService
    ) {
        super();
        this.onItemSelected = new Subject<any>();
        this.onItemRemoved = new Subject<any>();
    }

    async ngOnInit() {
        this.searchResultService.receiveContext(this.componentFactoryResolver, this.injector);

        if (this.results && this.results.length > 1) {
            await this.popupAdvancedSearchModal({ results: this.results });
        } else if (this.results && this.results.length == 1) {
            this.result = this.results[0];
            this.onSelect(this.result);
        }

    }

    onSelect(customer) {
        this.onItemSelected.next(customer);
    }

    onRemove() {
        this.onItemRemoved.next();
    }

    async popupAdvancedSearchModal(data = null) {
        const self = this;
        const realData = new CustomerSearchViewContext(data);
        const dialogRef = this.modalService.open(CustomerSearchViewModalComponent, realData);

        dialogRef.afterClosed().subscribe(customerNumberId => {
            self.result = data.results.find(x => x.customerNumber == customerNumberId);
            if (self.result) {
                self.onSelect(self.result);
            } else {
                if (customerNumberId) {
                    this.customerService.getCustomer(customerNumberId).subscribe(customer => {
                        if (customer) {
                            self.result = self.buildOutCustomerResult(customer, customerNumberId);
                            self.onSelect(self.result);
                        }
                    });
                } else {
                    // Clear hide searchbox flag
                    self.onRemove();
                }
            }
        });
    }

    private buildOutCustomerResult(customer, customerNumberId): any {
        const legacySequenceNumber = customer.identifications && customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.LegacySequenceNumber.id);
        const legacyCustomerNumber = customer.identifications && customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.LegacyCustomerNumber.id);

        const credentialNumber = customer.identifications &&
			(customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.ArizonaDriverLicense.id) ||
				customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.ArizonaIDNumber.id) ||
				customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.OutofStateDriverCredential.id) ||
				customer.identifications.find(x => x.customerIdentificationTypeId == this.customerIdentificationTypes.OutofStateIdentificationCredential.id));

        let customerResult = {
            customerNumber: customerNumberId,
            legacyCustomerNumber: legacyCustomerNumber && legacyCustomerNumber.customerIdentificationValue,
            customerName: customer.nameDetail && customer.nameDetail.displayName,
            displayAddress: this.formatAddress(customer.mailingAddress),
            legacySequenceNumber: legacySequenceNumber && legacySequenceNumber.customerIdentificationValue,
            credentialNumberDisplayValue: credentialNumber ? (this.customerIdentificationTypes.FromId(credentialNumber.customerIdentificationTypeId).displayValue + ': ' + credentialNumber.customerIdentificationValue) : (this.customerIdentificationTypes.FromId(this.customerIdentificationTypes.CustomerID.id).displayValue + ': ' + customerNumberId),
            dateOfBirth: undefined
        };

        if (customer.biometric && customer.biometric.dateOfBirth) {
            customerResult.dateOfBirth = customer.biometric.dateOfBirth;
        }
        return customerResult;
    }

    private formatAddress(address): string {
        let addressString = '';
        if (address) {
            let jurisdiction = address.jurisdictionId ? this.jurisdictions.FromId(address.jurisdictionId).code + ' ' : '';
            let postalCode = address.postalCode || '';

            addressString = this.addCommaOrEmpty(address.addressLine1) +
				this.addCommaOrEmpty(address.addressLine2) +
				this.addCommaOrEmpty(address.city) +
				jurisdiction +
				postalCode;
        }
        return addressString;
    }

    private addCommaOrEmpty(str: string): string {
        return str ? `${str}, ` : '';
    }
}
